import { ISettingsStoreMemento } from '../flux/settings/SettingsStore'

const STORAGE_KEY = 'settings'

/**
 * Determines if there is any data stored for the application
 * @returns {boolean} true if there is else false
 */
function hasData() {
    const data = window.localStorage.getItem(STORAGE_KEY)
    return data === null ? false : data.length > 3
}

/**
 * Saves settings structure to local storage
 * @param {ISettingsStoreMemento} settings Settings to save
 */
function save(settings: ISettingsStoreMemento) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings))
}

/**
 * Loads the settings from local storage
 * @returns {ISettingsStoreMemento} Settings or {} if null
 */
function load(): ISettingsStoreMemento {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    return stored === null ? {} : JSON.parse(stored)
}

export { load, save, hasData }
